import { Interpolation, createGlobalStyle } from 'styled-components';

const breakpoints = {
  xl: '1200px',
  lg: '1200px',
  md: '950px',
  sm: '600px',
  xs: '480px',
};

export const media = {
  xl: (styles: Interpolation<object>) => `@media (max-width: ${breakpoints.xl}) { ${styles} }`,
  lg: (styles: Interpolation<object>) => `@media (max-width: ${breakpoints.lg}) { ${styles} }`,
  md: (styles: Interpolation<object>) => `@media (max-width: ${breakpoints.md}) { ${styles} }`,
  sm: (styles: Interpolation<object>) => `@media (max-width: ${breakpoints.sm}) { ${styles} }`,
  xs: (styles: Interpolation<object>) => `@media (max-width: ${breakpoints.xs}) { ${styles} }`,
};

export const colors = {
  primary: '#632573',
  primaryDark: '#2a042d',
  lp1: '#f8f5f9',
  lp2: '#f4f0f6',
  lp3: '#9C84AD',
  verdigris: '#43b8b0',
  text: '#353535',
  verdigrisGradient: 'linear-gradient(89.99deg, #43B8B0 0.01%, #4D6978 99.99%)',
  verdigrisGradientEnd: '#4d6e7c',
  colorVerdigris: '#43B8B0',
  colorVerdigrisDark: '#4D6978',
  colorWhite: '#fff',
};

export const GlobalStyle = createGlobalStyle`
 .input-endorment {
    position: relative;
    display: flex;
    align-items: center;

    &__content {
      position: absolute;
      right: 0;
      width: 45px;
      padding-right: 3px;
      background-color: ${colors.primary};
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-weight: 500;
      border-top-right-radius: 50px;
      border-bottom-right-radius: 50px;
    }
  }

  .radio-container{
    display: flex;
    align-items: center;
    grid-gap: 21px;
    &__item{
      display: flex;
      align-items: center;
      grid-gap: 12px;
      &__label{
        font-weight: 400;
        color: ${colors.text};
      }
    }

    &--column{
      flex-direction: column;
      align-items: flex-start;
      grid-gap: 0;
  
      .radio-container__item{
        margin-bottom: 12px !important;
      }
      
    }
  }
`;
